export const NextIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="10.715" height="16" viewBox="0 0 10.715 16">
        <g id="button-pijl" transform="translate(-9 -7.174)">
            <path id="Shape" d="M10.135,6.742a1.658,1.658,0,0,1,0,2.518L2.737,15.6A1.658,1.658,0,0,1,0,14.343V1.656A1.658,1.658,0,0,1,2.737.4Z" transform="translate(9 7.172)" fill="#fff"/>
        </g>
    </svg>
)